import { render, staticRenderFns } from "./EditNoticeAdmin.vue?vue&type=template&id=b580457a&scoped=true"
import script from "./EditNoticeAdmin.vue?vue&type=script&lang=js"
export * from "./EditNoticeAdmin.vue?vue&type=script&lang=js"
import style0 from "./EditNoticeAdmin.vue?vue&type=style&index=0&id=b580457a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b580457a",
  null
  
)

export default component.exports